import { Grid, Typography } from "@mui/material";
import RefreshIcon from "@mui/icons-material/Refresh";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import React, { FC } from "react";
import useLocales from "../../../hooks/useLocales";

interface Props {
  tableName?: string;
  actions?: React.ReactNode;
  children: any;
  loading?: boolean;
  filters?: any;
  refetch?: any;
}

const List: FC<Props> = (props) => {
  const { translate } = useLocales();
  const { tableName, children, refetch } = props;

  return (
    <div className="panel">
      <div className="panel-container">
        <Grid container spacing={2} justifyContent="space-between">
          <Grid item>
            <div className="panel-header">
              <Typography variant="h3">{tableName}</Typography>
            </div>
          </Grid>
          <Grid item sx={{ marginRight: 1 }}>
            <div className="panel-header">
              <Tooltip title={translate("actions.refresh")}>
                <IconButton onClick={refetch}>
                  <RefreshIcon />
                </IconButton>
              </Tooltip>
            </div>
          </Grid>
        </Grid>
        <div className="panel-body">{children}</div>
      </div>
    </div>
  );
};

export default List;
